import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  t,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class AssetReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_category: "All Categories",
      filter_status: "All Status",
      filter_location: "All Locations",

      // -----------------------------------
      // Mock Data: Summary Stats (ปรับให้ตรงกับ Cost Report)
      // -----------------------------------
      summary: {
        total: "125,400",
        total_change: "+5.3% vs previous",
        completed: "68,200",
        completed_rate: "54% of total",
        in_progress: "42,800",
        in_progress_rate: "34% of total",
        pending: "14,400",
        pending_rate: "12% of total",
      },
      // -----------------------------------
      // Mock Data: Cost by Asset (ปรับจาก SLA Metrics)
      // -----------------------------------
      data: [
        {
          category: "HVAC",
          total: "18,500",
          avgResponse: "12,800",
          avgResolution: "3,200",
          responseSla: "34,500",
          resolutionSla: "27.5%",
          breaches: "Chiller Unit #1", // สลับตำแหน่งเพื่อใช้แสดงชื่อในตารางโครงสร้างเดิม
        },
        {
          category: "HVAC",
          total: "15,200",
          avgResponse: "8,400",
          avgResolution: "2,800",
          responseSla: "26,400",
          resolutionSla: "21%",
          breaches: "Chiller Unit #2",
        },
        {
          category: "Electrical",
          total: "12,000",
          avgResponse: "9,200",
          avgResolution: "2,400",
          responseSla: "23,600",
          resolutionSla: "18.8%",
          breaches: "Generator Set",
        },
        {
          category: "HVAC",
          total: "10,500",
          avgResponse: "6,800",
          avgResolution: "2,200",
          responseSla: "19,500",
          resolutionSla: "15.5%",
          breaches: "AHU Units",
        },
      ],

      // -----------------------------------
      // Mock Data: Recent Invoices (ปรับจาก SLA Breach)
      // -----------------------------------
      breachDetails: [
        {
          id: "INV-2025-024",
          date: "Feb 15, 2025",
          category: "Monthly maintenance service - February",
          type: "Pending",
          target: "42,500",
          actual: "-",
          reason: "Monthly service",
        },
        {
          id: "INV-2025-018",
          date: "Jan 31, 2025",
          category: "Monthly maintenance service - January",
          type: "Paid",
          target: "38,900",
          actual: "-",
          reason: "Monthly service",
        },
        {
          id: "INV-2025-012",
          date: "Jan 15, 2025",
          category: "Emergency repair - Chiller Unit #2",
          type: "Paid",
          target: "24,000",
          actual: "-",
          reason: "Repair",
        },
      ],
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { summary, data, breachDetails } = this.state;

    return (
      <div
        className="w-100 min-vh-100 pb-5"
        style={{ backgroundColor: "#F4F7FE" }}
      >
        <NavbarCustomer />
        <div className="body px-4 mt-3">
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">
              {t("cost_report")}
            </h3>
            <div className="text-secondary text-14">
              {t("cost_report_desc")}
            </div>
          </div>

          {/* Filter Bar */}
          <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-end gap-3 border border-light">
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("period")}
              </label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("this_month")}</option>
              </select>
            </div>
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("category")}
              </label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("all_categories")}</option>
              </select>
            </div>
            <div className="flex-grow-1" style={{ minWidth: "200px" }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">
                {t("location")}
              </label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("all_locations")}</option>
              </select>
            </div>
            <button
              className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center"
              style={{ height: "42px", backgroundColor: "#e67e22" }}
            >
              <span className="icon me-2">{"\uf0b0"}</span> {t("apply_filters")}
            </button>
          </div>

          {/* KPI Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-primary rounded-4 shadow-sm p-3 bg-white h-100" style={{ borderLeftColor: "#e67e22 !important" }}>
                <div className="text-primary text-12 fw-bold mb-1" style={{ color: "#e67e22" }}>
                  {t("total_cost")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{summary.total}</h2>
                <div className="text-primary text-10 fw-bold" style={{ color: "#e67e22" }}>{summary.total_change}</div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-success rounded-4 shadow-sm p-3 bg-white h-100" style={{ borderLeftColor: "#3498db !important" }}>
                <div className="text-success text-12 fw-bold mb-1" style={{ color: "#3498db" }}>
                  {t("labor_cost")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{summary.completed}</h2>
                <div className="text-success text-10 fw-bold" style={{ color: "#3498db" }}>
                  {summary.completed_rate}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-warning rounded-4 shadow-sm p-3 bg-white h-100" style={{ borderLeftColor: "#2ecc71 !important" }}>
                <div className="text-warning text-12 fw-bold mb-1" style={{ color: "#2ecc71" }}>
                  {t("parts_cost")}
                </div>
                <h2 className="fw-bold text-dark mb-1">
                  {summary.in_progress}
                </h2>
                <div className="text-warning text-10 fw-bold" style={{ color: "#2ecc71" }}>
                  {summary.in_progress_rate}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-danger rounded-4 shadow-sm p-3 bg-white h-100" style={{ borderLeftColor: "#9b59b6 !important" }}>
                <div className="text-danger text-12 fw-bold mb-1" style={{ color: "#9b59b6" }}>
                  {t("service_fee")}
                </div>
                <h2 className="fw-bold text-dark mb-1">{summary.pending}</h2>
                <div className="text-danger text-10 fw-bold" style={{ color: "#9b59b6" }}>
                  {summary.pending_rate}
                </div>
              </div>
            </div>
          </div>

          {/* Graphs Area */}
          <div className="row g-4 mb-4">
            <div className="col-lg-8">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">{t("monthly_cost_trend")}</h6>
                <div
                  className="d-flex align-items-center justify-content-center bg-light rounded-3"
                  style={{ height: "250px" }}
                >
                  <span className="text-secondary opacity-50">
                    [ Monthly Cost Trend Chart ]
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">
                  {t("cost_by_category")}
                </h6>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: "250px" }}
                >
                  <div className="position-relative d-flex align-items-center justify-content-center">
                    <div
                      className="rounded-circle border border-5 border-warning"
                      style={{ width: "150px", height: "150px" }}
                    ></div>
                    <div className="position-absolute icon text-warning text-24">
                      {"\uf200"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Details Table */}
          <div className="card border-0 rounded-4 shadow-sm pb-2 overflow-hidden bg-white mb-4">
            <div className="p-4 border-bottom border-light">
              <h6 className="fw-bold text-dark mb-0">
                {t("cost_by_asset")}
              </h6>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                    <th className="py-3 px-4 border-0">{t("asset")}</th>
                    <th className="py-3 border-0">{t("category")}</th>
                    <th className="py-3 border-0">{t("labor")}</th>
                    <th className="py-3 border-0">{t("parts")}</th>
                    <th className="py-3 border-0">{t("service_fee")}</th>
                    <th className="py-3 border-0">{t("total")}</th>
                    <th className="py-3 border-0 text-center">% {t("of_total")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-3 px-4 fw-bold text-dark text-13">
                        {item.breaches}
                      </td>
                      <td className="text-secondary text-13">{item.category}</td>
                      <td className="text-secondary text-13">
                        {item.total}
                      </td>
                      <td className="text-secondary text-13">
                        {item.avgResponse}
                      </td>
                      <td className="text-secondary text-13">
                        {item.avgResolution}
                      </td>
                      <td className="fw-bold text-13">
                        {item.responseSla}
                      </td>
                      <td className="text-center text-secondary text-13">
                        {item.resolutionSla}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Recent Invoices Table */}
          <div className="border border-light rounded-4 overflow-hidden">
            <div className="p-3" style={{ backgroundColor: "#f8f9fa" }}>
              <h6 className="fw-bold text-dark mb-0 text-13">
                <span className="icon me-2">{"\uf51e"}</span>{" "}
                {t("recent_invoices")}
              </h6>
            </div>
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr className="text-secondary text-11 fw-bold bg-light bg-opacity-25">
                    <th className="py-3 px-4 border-0">{t("invoice_no")}</th>
                    <th className="py-3 border-0">{t("date")}</th>
                    <th className="py-3 border-0">{t("description")}</th>
                    <th className="py-3 border-0">{t("status")}</th>
                    <th className="py-3 border-0">{t("amount")}</th>
                    <th className="py-3 border-0">{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {breachDetails.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-3 px-4 fw-bold text-dark text-13" style={{ color: "#e67e22" }}>
                        {item.id}
                      </td>
                      <td className="text-secondary text-13">{item.date}</td>
                      <td className="text-secondary text-13">
                        {item.category}
                      </td>
                      <td>
                        <span className={`badge bg-${item.type === 'Paid' ? 'success' : 'warning'}-light text-${item.type === 'Paid' ? 'success' : 'warning'} rounded-pill px-3 py-1 fw-bold text-10 border`}>
                          {item.type}
                        </span>
                      </td>
                      <td className="fw-bold text-13">{item.target}</td>
                      <td className="text-center">
                        <span className="icon text-primary pointer">{"\uf019"}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Actions */}
          {/* <div className="d-flex justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border border-light">
            <div className="text-secondary text-12">
              {t("report_generated")}: Feb 19, 2025 at 10:30 AM
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-white border px-3 py-2 text-danger fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c1"}</span> {t("export_pdf")}
              </button>
              <button className="btn btn-white border px-3 py-2 text-success fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c3"}</span>{" "}
                {t("export_excel")}
              </button>
              <button className="btn btn-primary px-4 py-2 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center" style={{ backgroundColor: "#e67e22" }}>
                <span className="icon me-2">{"\uf02f"}</span>{" "}
                {t("print_report")}
              </button>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}